import { h } from 'preact'

const CloseIcon = ({
  size = 32,
  color = '#8496AF',
  onClick,
  className,
}: {
  size?: number
  color?: string
  onClick?: () => void
  className?: string
}) => (
  <svg
    className={className}
    onClick={onClick}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
  >
    <path
      fill={color}
      d="M18.56 16l10.912-10.912c0.704-0.704 0.704-1.856 0-2.56s-1.856-0.704-2.56 0l-10.912 10.912-10.912-10.912c-0.704-0.704-1.856-0.704-2.56 0s-0.704 1.856 0 2.56l10.912 10.912-10.912 10.912c-0.704 0.704-0.704 1.856 0 2.56 0.352 0.352 0.832 0.544 1.28 0.544 0.48 0 0.928-0.192 1.28-0.544l10.912-10.912 10.912 10.912c0.352 0.352 0.8 0.544 1.28 0.544 0.448 0 0.928-0.192 1.28-0.544 0.704-0.704 0.704-1.856 0-2.56l-10.912-10.912z"
    />
  </svg>
)

export default CloseIcon
